export default {
  title: "HHS"
};
